import "./IndustryVerticals.scss"
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';

const IndustrialVerticalImg1 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img1.png";
const IndustrialVerticalImg2 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img2.png";
const IndustrialVerticalImg3 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img3.png";
const IndustrialVerticalImg4 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img4.png";
const IndustrialVerticalImg5 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img5.png";
const IndustrialVerticalImg6 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img6.png";
const IndustrialVerticalImg7 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img7.png";
const IndustrialVerticalImg8 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img8.png";

const IndustrialVerticalBorder1 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border1.png";
const IndustrialVerticalBorder2 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border2.png";
const IndustrialVerticalBorder3 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border3.png";
const IndustrialVerticalBorder4 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border4.png";
const IndustrialVerticalBorder5 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border5.png";
const IndustrialVerticalBorder6 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border6.png";
const IndustrialVerticalBorder7 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border7.png";
const IndustrialVerticalBorder8 = "https://cdn.deepsense.space/Ripple/World/industrial-vertical-img-border8.png";


export const IndustryVerticals = (props) => {
    const data1 = [
        {
            'img':IndustrialVerticalImg1,
            'title':'Food & Beverages',
            'outter_bg':IndustrialVerticalBorder1,
        },
        {
            'img':IndustrialVerticalImg2,
            'title':'Electronics',
            'outter_bg':IndustrialVerticalBorder2,
        },
        {
            'img':IndustrialVerticalImg3,
            'title':'Automobiles',
            'outter_bg':IndustrialVerticalBorder3,
        },
        {
            'img':IndustrialVerticalImg4,
            'title':'Entertainment',
            'outter_bg':IndustrialVerticalBorder4,
        }

    ];
    const data2 = [
        {
            'img':IndustrialVerticalImg5,
            'title':'Beauty & Wellness',
            'outter_bg':IndustrialVerticalBorder5,
        },
        {
            'img':IndustrialVerticalImg6,
            'title':'Fashion',
            'outter_bg':IndustrialVerticalBorder6,
        },
        {
            'img':IndustrialVerticalImg7,
            'title':'Education',
            'outter_bg':IndustrialVerticalBorder7,
        },
        {
            'img':IndustrialVerticalImg8,
            'title':'Kitchen Appliances',
            'outter_bg':IndustrialVerticalBorder8,
        }
    ];

    return(
        <div className={"industry-vertical-component"}>
            <div className={"content-section"}>
                <p className={"title"}>Industry Verticals</p>
                <p className={"description"}>
                    Ripple AR AI Engine powers World Effects, Face Effects, and Image Target experiences that work in the browser across all devices which can be used across a wide range of industries. ​
                </p>
            </div>
            <MDBContainer className={"industry-vertical-container"}>
                <MDBRow>
                    {
                        data1.map((item,index)=>{
                            return(
                                <MDBCol size='6' sm={'3'} className='col-example' key={index}>
                                    <IndustryVerticalsCard cardData={item}/>
                                </MDBCol>
                            )
                        })
                    }
                </MDBRow>
                <div className={"spacer"}/>
                <MDBRow>
                    {
                        data2.map((item,index)=>{
                            return(
                                <MDBCol size='6' sm={'3'} className='col-example' key={index}>
                                    <IndustryVerticalsCard cardData={item}/>
                                </MDBCol>
                            )
                        })
                    }
                </MDBRow>
            </MDBContainer>
        </div>
    );
}

const IndustryVerticalsCard = (props) => {
    const {cardData} = props;
    return(
        <div className={"industry-vertical-card-component"}
             style={{backgroundImage:`url(${cardData.outter_bg})`}}
        >
            <div className={"inner-content"}>
                <img src={cardData.img} alt={"IndustrialVerticalImg"} className={"img-fluid"}/>
                <p className={"title"}>{cardData.title}</p>
            </div>
        </div>
    )
}
